import {Inject, Injectable} from '@angular/core';
import {IAppRestClient} from "../../../rest-clients/application/app/i-app-rest.client";
import {appRestClientInjectionToken} from "../../../rest-clients/application/app/app-rest-client-injection-token";
import {IAppService} from "./i-app.service";
import {ICreateAppForm} from 'src/app/rest-clients/application/app/forms/i-create-app.form';
import {IGetAppPageForm} from 'src/app/rest-clients/application/app/forms/i-get-app-page.form';
import {IApp} from "../../../models/application/i-app";
import {ICreateRecordResponse, IPage} from '@zaeper/communication-lib';

@Injectable()
export class AppService implements IAppService {
  constructor(@Inject(appRestClientInjectionToken) private readonly _appRestClient: IAppRestClient) {
  }

  public async createAppDraft(createAppForm: ICreateAppForm): Promise<string> {
    const response: ICreateRecordResponse = await this._appRestClient.createApp(createAppForm);
    return Promise.resolve(response.recordId);
  }

  public async getAppPage(getAppPageForm: IGetAppPageForm): Promise<IPage<IApp>> {
    return this._appRestClient.getAppPage(getAppPageForm);
  }
}
